/**
 * @license
 * Copyright (c) 2025 Handsoncode. All rights reserved.
 */
import { EmptyValue } from "../interpreter/InterpreterValue.mjs";
/**
 * Represents singleton vertex bound to all empty cells
 */
export class EmptyCellVertex {
  constructor() {}
  /**
   * Retrieves cell value bound to that singleton
   */
  getCellValue() {
    return EmptyValue;
  }
}